import { publicClient } from '@/core/publicClient';

export type PublicBanner = {
  id: string;
  title?: string;
  link_url?: string;
  desktop_image_path: string;
  mobile_image_path: string;
};

export const bannersPublicApi = {
  list: async (): Promise<PublicBanner[]> => {
    const res = await publicClient.get('/public/banners');
    return Array.isArray(res.data?.items) ? res.data.items : [];
  },
};
